function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(24.705882%,82.352941%,78.039216%)",
      fillOpacity: 1
    },
    d: "M 22.449219 9.117188 C 22.9375 8.628906 23.730469 8.628906 24.21875 9.117188 L 34.21875 19.117188 C 34.707031 19.605469 34.707031 20.394531 34.21875 20.882812 L 24.21875 30.882812 C 23.730469 31.371094 22.9375 31.371094 22.449219 30.882812 C 21.960938 30.394531 21.960938 29.605469 22.449219 29.117188 L 30.316406 21.25 L 6.667969 21.25 C 5.976562 21.25 5.417969 20.691406 5.417969 20 C 5.417969 19.308594 5.976562 18.75 6.667969 18.75 L 30.316406 18.75 L 22.449219 10.882812 C 21.960938 10.394531 21.960938 9.605469 22.449219 9.117188 Z M 22.449219 9.117188 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewArrowRight);
export default __webpack_public_path__ + "static/media/review-arrow-right.bccdaea20e4b82a2e6925b91a7caacbb.svg";
export { ForwardRef as ReactComponent };